import ListAbsoluteI from '../types.ts';

const getRenderKey: ListAbsoluteI['getRenderKey'] = function () {
    const { keyRender, keyResize, windowIsReady, realyItems } = this.props;

    return `${keyRender}${keyResize}${windowIsReady}${!!realyItems}`;
};

export default getRenderKey;
